import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Fade,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DoneIcon from "@mui/icons-material/Done";
import { AddBox } from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";
import { API, graphqlOperation } from "aws-amplify";
import { createtransporter } from "../../graphql";
import {
  showErrorSnackbar,
  showSuccessSnackbar,
  showWarningSnackbar,
} from "../snackBar/snakbar";
import DeleteModal from "./DeleteModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  // bgcolor: "background.paper",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  outline: "none",
  minWidth: "50%",
  // height: "60%",
};

export const heading = ["S.No", "GSTIN/TRANSIN", "Name", "Action"];

const Transporter = ({
  open,
  setList,
  list,
  setOpen,
  listTransporters,
  label,
  type,
}) => {
  const [backdropOpen, setBackdropOpen] = useState(false);

  const [deleteOpen, setDeleteOpen] = useState(false);
  const [newSetting, setNewSetting] = useState(false);
  const [editData, setEditData] = useState([]);
  const [transporterObj, setTransporterObj] = useState({ name: "", id: "" });
  const handleClose = () => {
    setOpen(false);
    setEditData("");
    setNewSetting(false);
  };
  console.log(list, "list");
  const handleNewSetting = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    // if (value.startsWith("0") || value.length > 9) {
    //   // showWarningSnackbar("Prefix shouldn't be starting with '0,/,-'")
    //   return;
    // } else

    setTransporterObj({
      ...transporterObj,
      [name]: value,
    });
  };
  const transporterChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    // if (value.startsWith("0") || value.length > 9) {
    //   // showWarningSnackbar("Prefix shouldn't be starting with '0,/,-'")
    //   return;
    // } else
    // if (name === "id") {
    //   if (/^[0-3][0-9][A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(value)) {
    //     setTransporterObj({
    //       ...transporterObj,
    //       [name]: value,
    //     });
    //   }
    // } else {
    setTransporterObj({
      ...transporterObj,
      [name]: value,
    });
    // }
  };
  const handleDelete = async (data) => {
    setDeleteOpen(false);
    setEditData("");
    const exp = Math.floor(new Date().getTime() / 1000);
    const transporterData = {
      transporterid: data.transporterid,
      transportername: data.transportername,
      transportergstin: data.transportergstin,
      expiredtimestamp: exp,
    };
    try {
      const resSalesSettings = await API.graphql(
        graphqlOperation(createtransporter, {
          transporterMasterInput: transporterData,
        })
      );
      console.log(resSalesSettings, "resSalesSettings");
      if (resSalesSettings.data.createtransporter.statuscode === "Success") {
        showSuccessSnackbar("The transporter deleted successfully");
        const updatedList = list.filter(
          (li) => li.transporterid !== data.transporterid
        );
        setList(updatedList);
      } else {
        showErrorSnackbar("Something went wrong");
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  console.log(open, "open");
  console.log(deleteOpen, "deleteOpen");
  const saveChanges = async () => {
    const transporterData = {
      transporterid: editData.transporterid ? editData.transporterid : 0,
      transportername: transporterObj.name,
      transportergstin: transporterObj.id,
      expiredtimestamp: 0,
    };
    const exists = list
      .filter((t) => t.transportergstin !== editData.transportergstin)
      .some((t) => t.transportergstin === transporterObj.id);
    if (exists) {
      showWarningSnackbar("This Transporter GSTIN already exists");
    } else if (
      editData.transportergstin === transporterObj.id &&
      editData.transportername === transporterObj.name
    ) {
      setEditData("");
    } else {
      if (
        /^[0-3][0-9][A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
          transporterObj.id
        ) &&
        transporterObj.name
      ) {
        try {
          const resSalesSettings = await API.graphql(
            graphqlOperation(createtransporter, {
              transporterMasterInput: transporterData,
            })
          );
          console.log(resSalesSettings, "resSalesSettings");
          if (
            resSalesSettings.data.createtransporter.statuscode === "Success"
          ) {
            listTransporters();
            if (editData.transportergstin) {
              showSuccessSnackbar("The transporter updated successfully");
              setEditData("");
            } else {
              setNewSetting(false);
              showSuccessSnackbar("The transporter created successfully");
            }
          } else {
            showErrorSnackbar("Something went wrong");
          }
        } catch (err) {
          console.log(err, "err");
        }
      } else {
        showWarningSnackbar("Please provide valid Transporter id and name");
      }
    }
  };
  console.log(list, "list");
  console.log(transporterObj, "transporterObj");
  return (
    <Modal
      aria-labelledby="transition-modal-tit"
      aria-describedby="transition-modal-descripn"
      open={open}
      onClose={handleClose}
    >
      <Fade in={open}>
        <Paper style={{ boxShadow: "none" }} sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "10px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Transporter settings
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          {/* {settingsFlag === "2" && ( */}
          <Box sx={{ padding: "10px", m: "10px" }}>
            <TableContainer
              component={Paper}
              sx={{
                maxHeight: 400,
                minWidth: "100%",
                "&::-webkit-scrollbar": {
                  width: "0.4em",
                  height: "0.4em",
                },
                ".MuiTableCell-root": {
                  padding: "8px 5px",
                },
              }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {heading.map((head) => (
                      <TableCell
                        style={{ color: "#fff" }}
                        sx={{
                          backgroundColor: "primary.main",
                          color: "#FFF",
                          lineHeight: "1rem",
                          textAlign: "center",
                        }}
                      >
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody
                  sx={{
                    ".MuiTableCell-root": {
                      backgroundColor: "transparent !important",
                    },
                  }}
                >
                  {newSetting === true ? (
                    <TableRow>
                      <TableCell></TableCell>
                      <TableCell
                        sx={{
                          width: "300px",
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          size="small"
                          label="GSTIN/TRANSIN"
                          name="id"
                          //   inputRef={prefixref}
                          value={transporterObj.id}
                          InputLabelProps={{
                            shrink: transporterObj.id !== "" ? true : false,
                          }}
                          onChange={transporterChange}
                          inputProps={{ maxLength: 15 }}
                        />
                      </TableCell>
                      <TableCell
                        sx={{
                          textAlign: "center",
                        }}
                      >
                        <TextField
                          size="small"
                          label="Name"
                          InputLabelProps={{
                            shrink: transporterObj.name !== "" ? true : false,
                          }}
                          name="name"
                          value={transporterObj.name}
                          onChange={transporterChange}
                        />
                      </TableCell>

                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Box>
                            <IconButton
                              sx={{
                                margin: "0px 2px",
                                padding: "5px",
                                backgroundColor: "#fbc7c78c",
                                "&:focus": {
                                  backgroundColor: "#d5d5d5",
                                },
                              }}
                              onClick={saveChanges}
                            >
                              <DoneIcon
                                sx={{
                                  fontSize: `15px`,
                                  color: "#6096d9",
                                }}
                              />
                            </IconButton>
                            <IconButton
                              sx={{
                                margin: "0px 2px",
                                padding: "5px",
                                backgroundColor: "#fbc7c78c",
                                "&:focus": {
                                  backgroundColor: "#d5d5d5",
                                },
                              }}
                              // ref={buttonRefclose}
                              onClick={() => setNewSetting(false)}
                            >
                              <CloseIcon
                                sx={{
                                  fontSize: "15px",
                                  color: "#eb6a6a",
                                }}
                              />
                            </IconButton>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    <></>
                  )}
                  {list &&
                    list.length > 0 &&
                    list.map((set, index) => (
                      <TableRow hover role="checkbox">
                        <TableCell
                          sx={{
                            textAlign: "center",
                          }}
                        >
                          {index + 1}
                        </TableCell>
                        <TableCell
                          sx={{
                            minWidth: "130px",
                            textAlign: "center",
                          }}
                          // className={
                          //   set.serialisactive === 0 ? "inactive-row" : ""
                          // }
                        >
                          {editData.value === set.value &&
                          deleteOpen === false ? (
                            //   deleteModal === false &&
                            //   activeValueModal === false
                            <TextField
                              size="small"
                              label="GSTIN/TRANSIN"
                              name="id"
                              // inputRef={prefixref}
                              value={transporterObj.id}
                              // InputLabelProps={{
                              //   shrink:
                              //     settingObj.prefix !== "" ? true : false,
                              // }}
                              onChange={handleNewSetting}
                              inputProps={{ maxLength: 15 }}
                            />
                          ) : set.value ? (
                            set.value
                          ) : (
                            ""
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            textAlign: "center",
                          }}
                          // className={
                          //   set.serialisactive === 0 ? "inactive-row" : ""
                          // }
                        >
                          {editData.value === set.value &&
                          deleteOpen === false ? (
                            //   &&
                            //   deleteModal === false &&
                            //   activeValueModal === false
                            <TextField
                              size="small"
                              label="Name"
                              // InputLabelProps={{
                              //   shrink:
                              //     settingObj.nextinvoicenumber !== ""
                              //       ? true
                              //       : false,
                              // }}
                              name="name"
                              value={transporterObj.name}
                              onChange={handleNewSetting}
                            />
                          ) : (
                            set.label
                          )}
                        </TableCell>

                        <TableCell
                          sx={{
                            minWidth: "120px",
                            textAlign: "center",
                          }}
                          // className={
                          //   set.serialisactive === 0 ? "inactive-row" : ""
                          // }
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            {editData.value === set.value &&
                            deleteOpen === false ? (
                              // &&
                              // deleteModal === false &&
                              // activeValueModal === false
                              <Box>
                                <IconButton
                                  disableRipple={false}
                                  aria-label="delete"
                                  sx={{
                                    margin: "0px 2px",
                                    padding: "5px",
                                    backgroundColor: "#fbc7c78c",
                                    "&:focus": {
                                      backgroundColor: "#d5d5d5",
                                    },
                                  }}
                                  // ref={editDoneRef}
                                  onClick={saveChanges}
                                >
                                  <DoneIcon
                                    sx={{
                                      fontSize: `15px`,
                                      color: "#6096d9",
                                    }}
                                  />
                                </IconButton>
                                <IconButton
                                  disableRipple
                                  aria-label="delete"
                                  sx={{
                                    margin: "0px 2px",
                                    padding: "5px",
                                    backgroundColor: "#fbc7c78c",
                                    "&:focus": {
                                      backgroundColor: "#d5d5d5",
                                    },
                                  }}
                                  // ref={buttonRefclose}
                                  onClick={() => setEditData("")}
                                >
                                  <CloseIcon
                                    sx={{
                                      fontSize: "15px",
                                      color: "#eb6a6a",
                                    }}
                                  />
                                </IconButton>
                              </Box>
                            ) : (
                              <Box>
                                <Tooltip
                                  placement="left"
                                  disableInteractive
                                  arrow
                                >
                                  <IconButton
                                    disableRipple={false}
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#D0EFFF",
                                    }}
                                    onClick={() => {
                                      //   if (set?.serialisactive == 0) {
                                      //     showWarningSnackbar(
                                      //       "You can't modify the inactive setting"
                                      //     );
                                      //   } else {
                                      setEditData(set);
                                      setTransporterObj({
                                        name: set.label,
                                        id: set.value,
                                      });
                                      setNewSetting(false);
                                    }}
                                    // disabled={set.serialisactive === 0}
                                  >
                                    <EditIcon
                                      sx={{
                                        fontSize: "15px",
                                        color: "#6096d9",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip
                                  title="Delete"
                                  placement="left"
                                  disableInteractive
                                  arrow
                                >
                                  <IconButton
                                    disableRipple={false}
                                    aria-label="delete"
                                    sx={{
                                      margin: "0px 2px",
                                      padding: "5px",
                                      backgroundColor: "#fbc7c7",
                                    }}
                                    onClick={() => {
                                      setEditData(set);
                                      setDeleteOpen(true);
                                    }}
                                  >
                                    <DeleteIcon
                                      sx={{
                                        fontSize: "15px",
                                        color: "#eb6a6a",
                                      }}
                                    />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            )}
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  dispaly: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Button
                  disableRipple={false}
                  disableElevation
                  size="small"
                  variant="text"
                  onClick={() => {
                    setEditData("");
                    setTransporterObj({ name: "", id: "" });
                    setNewSetting(true);
                  }}
                  //   disabled={mode === "AUTO" && !editData ? false : true}
                  startIcon={<AddBox />}
                  sx={{
                    fontSize: "14px",
                    marginTop: "15px",
                    color: "#5c5cd2",
                    fontStyle: "italic",
                    fontWeight: "bold",
                  }}
                >
                  Add new line
                </Button>
              </Box>
            </Box>
          </Box>
          {deleteOpen !== false ? (
            <DeleteModal
              open={deleteOpen !== false}
              setOpen={setDeleteOpen}
              func={() => {
                handleDelete(editData);
                setDeleteOpen(false);
              }}
              setFn={() => {
                setEditData("");
              }}
              // text={type === "IndustryType" ? "Industry Type" : "Business Type"}
            />
          ) : null}
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={backdropOpen}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </Paper>
      </Fade>
    </Modal>
  );
};

export default Transporter;
